<template>
  <b-card>
    <div v-if="loading">
      <b-skeleton width="100%" height="350px" />
    </div>
    <div v-else>
      <b-row>
        <!-- text and button -->
        <b-col
          sm="5"
          order-sm="1"
          order="2"
          class="d-flex justify-content-between flex-column mt-1 mt-sm-0"
        >
          <div>
            <h2 class="font-weight-bolder mb-25">
              {{ statistics.sessionsProgress }} %
            </h2>
            <b-card-text class="font-weight-bold mb-2">
              میزان پیشرفت
            </b-card-text>

            <h5 class="font-medium-2">
              <div
                class="d-flex mr-2 mb-1 flex-wrap"
                v-if="statistics.startSemester"
              >
                <b-card-text>
                  <feather-icon size="14" icon="CalendarIcon" /> تاریخ شروع :
                </b-card-text>

                <b-card-text>{{
                  calcDate(statistics.startSemester)
                }}</b-card-text>
              </div>

              <div
                class="d-flex mr-2 mb-1 flex-wrap"
                v-if="statistics.endSemester"
              >
                <b-card-text
                  ><feather-icon size="14" icon="CalendarIcon" /> تاریخ پایان :
                </b-card-text>

                <b-card-text>{{
                  calcDate(statistics.endSemester)
                }}</b-card-text>
              </div>
              <span
                class="text-danger mr-50"
                v-if="getDiff.time && getDiff.time.day < 0"
              >
                <b-card-text>این ترم تمام شده</b-card-text>
              </span>
              <span class="mr-50" v-else>
                <b-card-text>{{ getDiff.time.day }} روز مانده</b-card-text>
              </span>
            </h5>
            <h5>
              تعداد دوره ها
              {{ SemesterStatistics.courses.length }}
            </h5>
          </div>
        </b-col>

        <!-- dropdown and chart -->
        <b-col
          sm="7"
          cols="12"
          order-sm="2"
          order="1"
          class="d-flex justify-content-between flex-column text-right"
          style="overflow-x: auto"
        >
          <vue-apex-charts
            type="bar"
            height="300"
            width="400"
            :options="columnChart.chartOptions"
            :series="columnChart.series"
          />
        </b-col>
      </b-row>
      <hr />

      <!-- progress bar -->
      <b-row class="avg-sessions pt-50">
        <b-col cols="6" class="mb-2">
          <b-card-text class="mb-50">
            فروش: {{ numberWithCommas(statistics.goal) }} تومان
          </b-card-text>
          <b-progress value="50" max="100" height="6px" />
        </b-col>
        <b-col cols="6" class="mb-2">
          <b-card-text class="mb-50">
            دانشجویان: {{ statistics.users }}
          </b-card-text>
          <b-progress value="60" max="100" height="6px" variant="warning" />
        </b-col>
        <b-col cols="6">
          <b-card-text class="mb-50">
            جریمه پرداخت شده:
            {{ numberWithCommas(statistics.penaltiesPay) }} تومان
          </b-card-text>
          <b-progress
            value="70"
            max="100"
            height="6px"
            variant="success"
            class="mt-25"
          />
        </b-col>
        <b-col cols="6">
          <b-card-text class="mb-50">
            جریمه پرداخت نشده:
            {{ numberWithCommas(statistics.penaltiesNotPay) }} تومان
          </b-card-text>
          <b-progress
            value="90"
            max="100"
            variant="danger"
            height="6px"
            class="mt-25"
          />
        </b-col>
      </b-row>
    </div>
  </b-card>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BButton,
  BDropdown,
  BDropdownItem,
  BProgress,
  BCardText,
  BSkeleton,
} from "bootstrap-vue";
import VueApexCharts from "vue-apexcharts";
import Ripple from "vue-ripple-directive";
import { $themeColors } from "@themeConfig";
let moment = require("jalali-moment");
export default {
  components: {
    VueApexCharts,
    BCard,
    BRow,
    BCol,
    BButton,
    BCardText,
    BDropdown,
    BDropdownItem,
    BProgress,
    BSkeleton,
  },
  directives: {
    Ripple,
  },

  data() {
    return {
      SemesterStatistics: {},
      loading: false,
      getDiff: {},
    };
  },
  computed: {
    columnChart() {
      return {
        series: [
          {
            name: "میزان پیشرفت  ",
            data: this.SemesterStatistics.courses.map((x) =>
              Math.ceil((x.count_seen / x.all) * 100)
            ),
          },
        ],
        chartOptions: {
          chart: {
            stacked: true,
            toolbar: {
              show: false,
            },
            label: {
              show: false,
            },
          },
          colors: [$themeColors.primary],
          plotOptions: {
            bar: {
              columnWidth: "30%",
            },
          },
          dataLabels: {
            enabled: false,
          },
          legend: {
            show: true,
            position: "top",
            fontSize: "14px",
            fontFamily: "Montserrat",
            horizontalAlign: "left",
          },
          stroke: {
            show: false,
          },
          grid: {
            xaxis: {
              lines: {
                show: false,
              },
            },
            yaxis: {
              lines: {
                show: false,
              },
            },
          },
          xaxis: {
            categories: this.SemesterStatistics.courses.map(
              (x) => x.course_name
            ),
            labels: {
              show: false,
            },
          },
          yaxis: {
            opposite: false,
            show: true,
            max: 100,
            min: 0,
            step: 10,
          },
          fill: {
            opacity: 1,
          },
        },
      };
    },
    statistics() {
      return {
        penaltiesPay:
          this.SemesterStatistics.penalties &&
          this.SemesterStatistics.penalties.payed
            ? this.SemesterStatistics.penalties.payed
            : 0,
        goal: this.SemesterStatistics.earning || 0,
        // lastDays: ["Last 28 Days", "Last Month", "Last Year"],
        penaltiesNotPay:
          this.SemesterStatistics.penalties &&
          this.SemesterStatistics.penalties.not_payed
            ? this.SemesterStatistics.penalties.not_payed
            : 0,
        endSemester: this.SemesterStatistics.ended_at || 0,
        startSemester: this.SemesterStatistics.started_at || 0,
        salesBar: {
          series: [
            {
              colors: ["#000000"],
              data: [],
              name: [],
            },
            {
              colors: ["#ff0000"],

              data: ["10", "20", "30"],
              name: [],
            },
          ],
        },
        sessionsProgress:
          Math.ceil(
            (this.SemesterStatistics.progress.count_seen /
              this.SemesterStatistics.progress.all) *
              100
          ) || 0,
        users: this.SemesterStatistics.students || 0,
      };
    },
  },
  created() {
    this.getSemesterStatistics();
  },
  methods: {
    async getSemesterStatistics() {
      this.loading = true;
      try {
        const { data } = await this.$http.get(
          `panel/semesters/${this.$route.params.id}/progress`
        );
        this.SemesterStatistics = data.data;

        this.getDiff = this.getDifference(
          moment.utc(this.SemesterStatistics.ended_at).local().format("X")
        );
        this.$emit("semesterProgress", this.SemesterStatistics.progress);
      } catch (e) {}
      this.loading = false;
    },
  },
};
</script>
